/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon20Regular = forwardRef('ArrowDUturnLeftUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M.179 7.514a.75.75 0 1 0 1.142.972L4.25 5.04V11a6.75 6.75 0 0 0 13.5 0V6.75a.75.75 0 0 0-1.5 0V11a5.25 5.25 0 1 1-10.5 0V5.04l2.929 3.445a.75.75 0 0 0 1.142-.972l-3.297-3.88a2 2 0 0 0-3.048 0L.18 7.515Z" })));
});
